import { Grid, Typography } from "@mui/material"
import { ReactComponent as WppIcon } from '../../../../../assets/icons/bnftsApps/bnftsWhatsApp.svg'
import { useTranslation } from "../../../../../i18n"

export default function BuyViaWppCard({ name }: { name?: string }) {
  const { t } = useTranslation()

  return (
    <Grid>
      <Grid
        container
        className={'paymentCard BuyViaWppCard'}
        sx={{
          display: 'flex',
          alignItems: 'center',
          borderRadius: '12px',
          p: { xs: '20px', md: '10px', lg: '20px' },
        }}
      >
        <Grid item sx={{ display: 'flex', flexDirection: 'column', flex: '1' }}>
          <Grid item>
            <Grid sx={{ display: 'flex', width: '100%' }}>
              <Typography
                variant="h6"
                dangerouslySetInnerHTML={{ __html: t.page2.payment.wppFinalizeTitle }}
                sx={{ fontSize: { xs: 16 }, alignSelf: 'center' }}
              />
            </Grid>
            <Typography
              variant="body2"
              dangerouslySetInnerHTML={{ __html: t.page2.payment.wppFinalizeDesc }}
              sx={{ fontSize: { xs: 12 } }}
            />
          </Grid>
        </Grid>
        <Grid item className={`DISABLED-card-icons`}>
          <WppIcon />
        </Grid>
      </Grid>
    </Grid>
  )
}